import { useEffect, useState } from "react";

import { getOtpResendCooldownSecondsRemaining } from "../lib/auth/authOtpConstants";

export function useLoginOtpResendCooldown(otpLastSentAt) {
  const [now, setNow] = useState(Date.now());
  const secondsRemaining = getOtpResendCooldownSecondsRemaining(
    otpLastSentAt,
    now
  );

  useEffect(() => {
    if (!otpLastSentAt || secondsRemaining <= 0) {
      return undefined;
    }

    setNow(Date.now());

    const intervalId = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [otpLastSentAt, secondsRemaining > 0]);

  return secondsRemaining;
}
